import { render, staticRenderFns } from "./MonitorPendencias.vue?vue&type=template&id=1fcb44bc&"
import script from "./MonitorPendencias.vue?vue&type=script&lang=js&"
export * from "./MonitorPendencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports